import { cva } from "class-variance-authority"

export const spinnerVariants = cva(
  "animate-spin rounded-full border-2",
  {
    variants: {
      variant: {
        default: "border-gray-300 border-t-[#0ab2b2]",
        secondary: "border-gray-300 border-t-[#353b51]",
        destructive: "border-gray-300 border-t-red-500",
        muted: "border-gray-300 border-t-gray-500",
      },
      size: {
        sm: "h-4 w-4",
        default: "h-6 w-6",
        lg: "h-8 w-8",
        xl: "h-12 w-12",
        "2xl": "h-16 w-16",
        "3xl": "h-32 w-32",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
) 